/* global localize, google, markerData */

import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

async function initMap() {
  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
    "marker"
  );
  const bounds = new google.maps.LatLngBounds();
  const map = new Map(document.getElementById("map"), {
    zoomControl: true,
    scaleControl: false,
    rotateControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    maxZoom: 16,
    mapId: "hitta-bygdegard",
  });
  const infowindow = new InfoWindow({
    maxWidth: 300,
  });
  const markers = markerData.map(function (data) {
    let contact = "";
    let { address, postalCode, city, email, phone, permalink } = data.meta;

    delete data.meta;

    const pinElement = new PinElement({
      background: "#087742",
      borderColor: "#087742",
      glyphColor: "#fff",
    });

    const marker = new AdvancedMarkerElement({
      position: data.position,
      content: pinElement.element,
      map,
    });

    if (email || phone) {
      contact = `
        <a href="mailto:${email}">${email}</a><br>
        ${phone}`;
    }

    var contentString = `
      <div class="infobox">
        <p class="title">${data.title}</p>
        <p>
          ${address}<br>
          ${postalCode} ${city}<br>
          ${contact}
        </p>
        <a class="button" href="${permalink}">Till mer information</a>
      </div>`;

    marker.addListener("click", function () {
      infowindow.setContent(contentString);
      infowindow.open(map, marker);
    });

    bounds.extend(marker.position);

    return marker;
  });

  const renderer = {
    render({ count, position }) {
      const $content = $(
        `<div class='cluster-icon'>
          <span>${count}</span>
          <img width="${35 + count / 20}px" src='${localize.icons.cluster1}'>
        </div>`
      );

      return new AdvancedMarkerElement({
        position,
        content: $content[0],
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  };

  // Add marker clusterer with custom icons
  new MarkerClusterer({ map, markers, renderer });

  // Center map over markers
  map.fitBounds(bounds, 0);
}

export default () => {
  const loader = new Loader({
    apiKey: "AIzaSyBkq97-W2XCG6uWAA4vlwFRlHxiwM0GRFo",
    version: "weekly",
  });

  loader.load().then(initMap);
};
